<!-- <div fxFlex="100" style="width: 100%;"  [style.height]="height"  [ngStyle.lt-md]="{'height': heightMob, 'object-fit': 'cover'}">
        <img  
    (click)="navigation==0?goToCategories(catId):link(navigatedUrl)"
    [src]="image" [alt]="altImage || 'images'" priority="low" fill   >

    </div> -->




    @if (type == 1) {
        <div>
            <div #diceContainer [style.height]="height" [ngStyle.lt-md]="{'height': heightMob}">
                <img [ngSrc]="image" loading="eager" fill style="object-fit: cover;" [alt]="image">
            </div>
            <!-- <div>
                <img
               [src]="image"
               width="100%"
               [style.height]="height"
               [ngStyle.lt-md]="{'height': heightMob, 'object-fit': 'cover'}"
               alt="images"
               loading="eager"
               fetchpriority="high"
             />
             
                 </div> -->
        </div>
        }
        @if(type ==2){
            
        <img width="100%" [style.height]="height" [ngStyle.lt-md]="{'height': heightMob, 'object-fit': 'cover'}"
            (click)="navigation==0?goToCategories(catId):link(navigatedUrl)" [alt]="altImage || 'images'" loading="eager"
            fetchpriority="high" [lazyLoad]="image" [defaultImage]="defaultImage">
        }
        
        <!-- <img width="100%" [style.height]="height" [ngStyle.lt-md]="{'height': heightMob, 'object-fit': 'cover'}"
            (click)="navigation==0?goToCategories(catId):link(navigatedUrl)"
            [src]="image" [alt]="altImage || 'images'" loading="eager" fetchpriority="high">  -->
        
        <!-- <img width="100%" [style.height]="height" [ngStyle.lt-md]="{'height': heightMob, 'object-fit': 'cover'}"
            (click)="navigation==0?goToCategories(catId):link(navigatedUrl)"
            [src]="image" [alt]="altImage || 'images'" loading="eager" fetchpriority="high">  -->
        
        <!-- <img width="100%" [style.height]="height" [ngStyle.lt-md]="{'height': heightMob, 'object-fit': 'cover'}"
            (click)="navigation==0?goToCategories(catId):link(navigatedUrl)"
             [alt]="altImage || 'images'" loading="eager" fetchpriority="high" [lazyLoad]="image" [defaultImage]="defaultImage" > -->
        
        
        <!-- <img [ngSrc]="optimizedImage"
        [width]="imageWidth"
        [height]="imageHeight"
        [alt]="altImage"
        [srcset]="imageSrcSet"
        sizes="(max-width: 600px) 480px, 1024px"
        loading="eager"
        priority="high"> -->
        
